import { isAPIError } from '@sales-center/common'
import { ActivityType } from '@user/features/Activity/ActivitiyTypes/typings'
import { fetchOverdueActivitiesCount } from '@user/features/Activity/store'
import { selectCurrentUser } from '@user/store/authorization'
import { useAppDispatch } from '@user/store/hooks'
import { IUserPosition } from '@user/store/salesTeam'
import getHours from 'date-fns/getHours'
import getMinutes from 'date-fns/getMinutes'
import set from 'date-fns/set'
import { useSelector } from 'react-redux'
import { Props } from '../EditActivityForm'
import { updateActivity } from '../effects/updateActivity.effect'
import { NormalizedActivity } from '../typings'

export function useHandlers(
  props: Props,
  activityTypes: ActivityType[],
  owners: IUserPosition[],
) {
  const { onClose, onSave } = props
  const appDispatch = useAppDispatch()
  const { userId } = useSelector(selectCurrentUser)

  async function onSubmit(model) {
    onClose()
    const result = await updateActivity({
      ...model,
      dueDate: !!model.dueDate
        ? set(new Date(model.dueDate), {
            hours: getHours(model.dueTime),
            minutes: getMinutes(model.dueTime),
          })
        : null,
      startDate: !!model.startDate
        ? set(model.startDate, {
            hours: getHours(model.startTime),
            minutes: getMinutes(model.startTime),
          })
        : null,
    })

    await appDispatch(fetchOverdueActivitiesCount(userId))

    if (!isAPIError(result) && onSave) {
      const normalizedActivity = normalizeActivity(model)
      onSave(normalizedActivity)
    }
  }

  function normalizeActivity(model): NormalizedActivity {
    const activity: NormalizedActivity = { ...model }
    activity.activityType =
      activityTypes.find((x) => x.id === activity.activityTypeId)?.name ?? ''
    activity.ownerId =
      activity.ownerId === 'unassigned' ? null : activity.ownerId
    activity.owner =
      owners.find((x) => x.userId === activity.ownerId)?.name ?? ''
    return activity
  }

  return { onSubmit }
}
